// src/components/AdminPanel/AdminLoginForm.js
import React, { useState } from "react";
import { Form, Input, Button, Typography, message, Alert } from "antd";
import axios from "axios";
import "./AdminLoginForm.css";
import { BASE_URL } from "../../api/rehabCenter";

const { Title } = Typography;

const AdminLoginForm = ({ onLoginSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState('');

  const handleLogin = async ({ username, password }) => {
    setLoading(true);
    setLoginError('');
    try {
      const response = await axios.post(`${BASE_URL}/rehab-center/admin/login`, {
        username,
        password,
      });
      if (response.data.success) {
        message.success("Login successful");
        onLoginSuccess(response.data.token); // Show admin panel
      } else {
        setLoginError("Invalid credentials");
      }
    } catch (error) {
      setLoginError("Invalid credentials");
    }
    setLoading(false);
  };

  return (
    <div className="admin-login-container">
      <Title level={3}>Admin Login</Title>
      {loginError && (
        <Alert
          message="Login Failed"
          description={loginError}
          type="error"
          showIcon
          closable
          onClose={() => setLoginError('')}
          style={{ marginBottom: '1rem' }}
        />
      )}
      <Form layout="vertical" onFinish={handleLogin}>
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: "Please enter username" }]}
        >
          <Input placeholder="Enter admin username" />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please enter password" }]}
        >
          <Input.Password placeholder="Enter admin password" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Login
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AdminLoginForm;